<template>
  <div class="">
    <div class="">
    <template v-for="tag in tags">
      <b-badge class="text-black font-size-13" :key="tag" v-if="tag.value">
        {{ tag.titulo }}: 
        {{ 
          (typeof tag.valueLabel != "undefined") ? 
            tag.valueLabel 
            : ((tag.type == "date")? formataDataBr(tag.value, true) : tag.value)
        }}
        <b-button
          @click="removeTag(tag)"
          variant="btn-outline-danger"
          size="sm"
        >
          <span class="mdn-Icon-fechar mdn-Icon--sm"></span>
        </b-button>
      </b-badge>
    </template> 
    </div>     
  </div>
</template>

<script>
  import { formataDataBr } from '@/common/boot/Utils'

  export default {
    name: 'SGPCustomTagsComponent',
    
    props: {
      tags: {
        type: Array,
        required: true,
        default: () => []
      }
    },

    data() {
      return {}
    },

    methods: {
      parseTagObject (value) {
        return JSON.parse(value)
      },

      removeTag (tagDeleted) {
        this.tags.forEach(tag => {
          if(tag.name === tagDeleted.name) {
            tag.value = ''
          }
        })
      },

      formataDataBr
    }
  }
</script>